module.exports = __webpack_public_path__ + "img/christmas-with-madrigal.7ee7f461.jpg";